import React, { useEffect, useMemo } from 'react';
import { Table } from '../ui-kit';
import { IconCalendar } from '../ui-kit/icons';
import AvailabilityCodeIcon from '../general/AvailabilityCodeIcon';
import { groupSchedulePath } from '../../utils/paths';
import { formatTimeHuman } from '../../utils/time';

const ContractWorkloadBreakdownTable = ({ workloadBreakdown, availabilityCodesById, groupsById, fetchGroups }) => {
  const workedIntervals = useMemo(() => workloadBreakdown?.worked_intervals || [], [workloadBreakdown]);
  const groupIds = useMemo(() => workedIntervals.map(i => i.group_id).filter(Boolean), [workedIntervals]);

  useEffect(() => {
    // only load the groups that we haven't loaded yet
    const notLoadedGroupIds = groupIds.filter(id => !groupsById[id]);

    if (notLoadedGroupIds.length > 0) fetchGroups({ params: { ids: notLoadedGroupIds, forceFetch: true } });
  }, [groupIds, groupsById, fetchGroups]);

  // don't render an empty table if there are no worked intervals
  if (workedIntervals.length === 0) return null;

  return (
    <Table striped bordered condensed>
      <thead>
        <tr>
          <th>{I18n.t('reporting.contracts.contracts.duty')}</th>
          <th>{I18n.t('attributes.start_time')}</th>
          <th>{I18n.t('attributes.end_time')}</th>
          <th>{I18n.t('activerecord.models.schedule/availability_code.one')}</th>
          <th>{I18n.t('comments')}</th>
          <th>{I18n.t('activerecord.attributes.schedule/schedule_interval.length_in_hours')}</th>
          <th>
            {I18n.t('reporting.contracts.contracts.accrued')} ({workloadBreakdown.time_unit})
          </th>
          <th>{I18n.t('activerecord.models.station.one')}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {workedIntervals.map(i => (
          <tr key={i.start_time}>
            <td>{i.duty_name}</td>
            <td>{formatTimeHuman(i.start_time)}</td>
            <td>{formatTimeHuman(i.end_time)}</td>
            <td>
              {availabilityCodesById[i.availability_code_id]?.name}{' '}
              <AvailabilityCodeIcon code={availabilityCodesById[i.availability_code_id]} />
            </td>
            <td>{i.comments}</td>
            <td className="number-column">{i.formatted.duration}</td>
            <td className="number-column">{i.formatted.accrued} </td>
            <td>
              {groupsById[i.group_id] && (
                <a target="_blank" href={`/groups/${i.group_id}`} rel="noreferrer">
                  {groupsById[i.group_id]?.name}
                </a>
              )}
            </td>
            <td>
              <a target="_blank" href={groupSchedulePath(i.group_id, i.start_time, i.end_time)} rel="noreferrer">
                <IconCalendar />
              </a>
            </td>
          </tr>
        ))}
        <tr>
          <th />
          <th />
          <th />
          <th />
          <th />
          <th className="number-column"> {workloadBreakdown.formatted.total_duration} </th>
          <th className="number-column"> {workloadBreakdown.formatted.total_accrued} </th>
          <th />
          <th />
        </tr>
      </tbody>
    </Table>
  );
};

export default ContractWorkloadBreakdownTable;
